import { render } from "./MAddToCartPopup.vue?vue&type=template&id=4ab0a13e&scoped=true&ts=true"
import script from "./MAddToCartPopup.vue?vue&type=script&lang=ts"
export * from "./MAddToCartPopup.vue?vue&type=script&lang=ts"

import "./MAddToCartPopup.vue?vue&type=style&index=0&id=4ab0a13e&lang=scss&scoped=true"
import "./MAddToCartPopup.vue?vue&type=style&index=1&id=4ab0a13e&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab0a13e"]])

export default __exports__